<template>
    <div class="row text-center">
        <div class="col-12">
            <div>{{$t('why_worth.description')}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WhyItsWorthIt"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/WhyItsWorthIt.vue